import { LogoutActionTypes } from './logout.types';

export const openLogoutPage = () => ({
    type: LogoutActionTypes.OPEN_LOGOUT_PAGE,
});

export const closeLogoutPage = () => ({
    type: LogoutActionTypes.CLOSE_LOGOUT_PAGE,
});
